
import { Vue, Component, Prop } from 'vue-property-decorator';
import all from '@/components/icons/all.vue';
import applications from '@/components/icons/applications.vue';
import comapnies from '@/components/icons/comapnies.vue';
import companyResources from '@/components/icons/companyResources.vue';
import documents from '@/components/icons/documents.vue';
// import FAVORITES from '@/components/icons/favorites.vue';
import groups from '@/components/icons/groups.vue';
import inbox from '@/components/icons/inbox.vue';
import invoicing from '@/components/icons/invoicing.vue';
import jobBoard from '@/components/icons/jobBoard.vue';
import jobPostings from '@/components/icons/jobPostings.vue';
import manageCompany from '@/components/icons/manageCompany.vue';
import managers from '@/components/icons/managers.vue';
import myTalentDirectory from '@/components/icons/myTalentDirectory.vue';
import personal from '@/components/icons/personal.vue';
import projects from '@/components/icons/Projects.vue';
import projectsDocuments from '@/components/icons/projectsDocuments.vue';
import scheduler from '@/components/icons/scheduler.vue';
import ALL_PROJECTS from '@/components/icons/talentHunt.vue';
import RESOURCES from '@/components/icons/companyResources.vue';
import talentDirectory from '@/components/icons/talentDirectory.vue';
import talentHunt from '@/components/icons/talentHunt.vue';
import timeSheet from '@/components/icons/timeSheet.vue';
import NETWORK from '@/components/icons/talentDirectory.vue';
import favorites from '@/components/icons/favourites.vue';
import CONNECTIONS from '@/components/icons/myTalentDirectory.vue';
import ManageProject from '@/components/icons/ManageProjectIcon.vue';
import NetworkIcon from '@/components/icons/NetworkIcon.vue';
import LocationIcon from "@/components/icons/LocationIcon.vue";
import MarketplaceIcon from '@/components/icons/MarketplaceIcon.vue';
import calendarNewIcon from "@/components/icons/CalendarIconNew.vue";
import MyDirectoryTalent from '@/components/icons/MyDirectoryTalent.vue';
import Resource from '@/components/icons/Resource.vue';
// import JOB_BLISS_MARKET_PLACE from '@/components/icons/jobBlissMarketPlace.vue';
import NavigationIcons from '@/entities/NavigationIcons';

@Component({
	components: {
		all,
		applications,
		comapnies,
		companyResources,
		documents,
		// FAVORITES,
		groups,
		inbox,
		invoicing,
		jobBoard,
		jobPostings,
		manageCompany,
		managers,
		myTalentDirectory,
		personal,
		projects,
		projectsDocuments,
		scheduler,
		ALL_PROJECTS,
		RESOURCES,
		talentDirectory,
		talentHunt,
		timeSheet,
		NETWORK,
		CONNECTIONS,
		ManageProject,
		NetworkIcon,
		LocationIcon,
		MarketplaceIcon,
		calendarNewIcon,
		favorites,
		MyDirectoryTalent,
		Resource,
		// JOB_BLISS_MARKET_PLACE,
	},
})
export default class BreadcrumbRootIcons extends Vue {
	@Prop({ type: String, required: true })
	readonly shownIconComponentName!: string;
	@Prop({ type: String, default: 'h-5 w-5' })
	readonly iconSizeClasses!: string;

	get iconClasses(): Object {
		const iconsWithStroke = [NavigationIcons.NOTIFICATIONS].some(
			(iconName) => iconName === this.shownIconComponentName
		);

		return {
			'stroke-icon-primary': iconsWithStroke,
		};
	}
}
